import { Typography, TypographyProps } from "@mui/material";
import * as React from "react";

interface IProps {
    text: string | string[] | undefined | null;
    splitChar?: string;
    keepSplitChar?: boolean;
    removeEmptyText?: boolean;
    separator?: React.ReactNode;
    color?: MprcColors | "inherit";
    typographProps?: Omit<TypographyProps, "color">;
}

export const MprcStringToHtml: React.FC<IProps> = ({ text, splitChar = ',', separator = <br />, keepSplitChar, removeEmptyText = false, color = "inherit", typographProps }) => {

    if (text == undefined || text == null || text.length == 0)
        return null;

    var splitText = Array.isArray(text)
        ? text.filter(p => p != null && p != undefined)
        : (removeEmptyText)
            ? text.split(splitChar).filter(p => p != "")
            : text.split(splitChar);

    return (

        <Typography component="div" variant="inherit" {...typographProps} color={color}>
            {
                splitText.map((v, index) => (
                    <React.Fragment key={index}>
                        {v.trim()}{keepSplitChar && splitChar}
                        {index < splitText.length - 1 ? (separator ?? null) : null}
                    </React.Fragment>)
                )
            }
        </Typography>

    );
};
